const PRODUCTION_HOSTNAME = "pol.research-ag.com";

export function isProduction() {
  return window.location.hostname === PRODUCTION_HOSTNAME;
}
